import { Component, inject } from '@angular/core';
import { Brand } from '../../shared/ui/brand';
import { ActivatedRoute } from '@angular/router';
import { LogoutErrorInfo, logoutErrorFor } from '../../core/models/logout.model';

/**
 * Richiesta di logout rifiutata.
 *
 * È l'indirizzo su cui sso-bck rimanda il browser quando `/sso/v1/end-session` non accetta
 * la richiesta (`security.sso.logout-error-url`), con il motivo in `?error=`.
 *
 * Qui il giro finisce: a differenza della conferma non c'è un opaque da consumare né una
 * destinazione dove tornare — l'errore riguarda proprio la validità di quella
 * destinazione, quindi non ci si può fidare di nulla che sia arrivato nella richiesta.
 */
@Component({
  selector: 'app-logout-error',
  imports: [Brand],
  templateUrl: './logout-error.html',
  styleUrl: './logout.scss',
})
export class LogoutError {
  private route = inject(ActivatedRoute);

  private readonly resolved = logoutErrorFor(this.route.snapshot.queryParamMap.get('error'));

  protected readonly info: LogoutErrorInfo = this.resolved.info;

  /**
   * Il codice da riportare, ma solo se è uno di quelli che l'SSO emette davvero: un valore
   * inventato nella query string non compare, così la pagina non presta la propria
   * credibilità a del testo scritto da chi ha costruito il link.
   */
  protected readonly code = this.resolved.knownCode;
}
